import { Text, TextField } from '../../../../../components';
import {
  Dialog,
  DialogActions,
  DialogButton,
  DialogContent,
  ModalInstance,
} from '../../../../../components/modals';
import { useStore } from '../../../../../store';
import { ProductHelp } from '../../../../../store/constants/help';
import { onSuccess } from '../../../../../utils/errors';
import PulseKeys from '../../../../pulse-keys/store/PulseKeys';

const exportKeysDialog = new ModalInstance<ExportKeysOptions>(
  'ExportKeysDialog',
);

export default function ExportKeysDialog() {
  const [options] = exportKeysDialog.useOptions();
  const { pulseKeyStore } = useStore();

  if (!options) {
    return null;
  }

  const { pulseKeys } = options;

  async function markDistributed() {
    await pulseKeyStore.markKeysDistributed(pulseKeys.items);
    onSuccess('Generated keys marked as distributed');
  }

  return (
    <Dialog
      onClose={() => exportKeysDialog.close('cancel')}
      title="Your newly generated keys"
    >
      <DialogContent>
        <Text>{ProductHelp.exportPulseKeys.topText}</Text>
        <TextField
          InputProps={{ readOnly: true }}
          margin="dense"
          multiline
          rows={10}
          sx={{ mb: 2 }}
          value={pulseKeys.toString()}
          variant="outlined"
        />
        <Text>{ProductHelp.exportPulseKeys.text}</Text>
      </DialogContent>
      <DialogActions>
        <DialogButton
          icon="save"
          onClick={pulseKeys.exportAll}
          title="Save As"
        />
        <DialogButton
          icon="copy"
          onClick={pulseKeys.copyAllToClipboard}
          title="Copy to clipboard"
        />
        <DialogButton onClick={markDistributed} title="Mark Distributed" />
        <DialogButton
          onClick={() => exportKeysDialog.close('cancel')}
          title="Close"
          type="secondary"
        />
      </DialogActions>
    </Dialog>
  );
}

export async function showExportKeysDialog(pulseKeys: PulseKeys) {
  await exportKeysDialog.show({ pulseKeys });
}

export interface ExportKeysOptions {
  pulseKeys: PulseKeys;
}
